export const dateForFrontend = (date?: string | null, options?: Intl.DateTimeFormatOptions) => {
  if (!date) return null;
  return new Date(date).toLocaleDateString('ru-RU', options);
};

export const formatDateToISO = (dateString?: string | null): string | undefined => {
  if (!dateString) return undefined;
  return new Date(dateString).toISOString().split('T')[0];
};